import axios from "axios";

export default class SalonNominationController {
    static async index(salonId: number | string) {
        const result = await axios.get<Jury.Resources.Nomination[]>(`/api/jury/salons/${salonId}/nominations`)
        return result.data
    }
}